module.exports = __webpack_public_path__ + "img/logo.9db11ab1.jpg";